export const FastlaneTrackingEvents = {
  TestModeRevertedToManual: 'FastlaneWizardTestModeRevertedToManual',
  CancelFastlaneWizard: 'FastlaneWizardCancel',
  TestModeIFrameFailedToLoad: 'FastlaneWizardTestModeIFrameFailedToLoad',
  RevertToManual: 'fastlane_revert_to_manual',
} as const
